import { IFieldStructure } from 'constants/valuesInterfaces/interfaces'

export const fields: Array<IFieldStructure> = [
	{
		idCampo: 'barCode',
		descrip: '',
		label: 'Código barra',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'number_from',
		descrip: '',
		label: 'Desde',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'number_quantity',
		descrip: '',
		label: 'Cantidad',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'lote',
		descrip: '',
		label: 'Partida',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'fec_vto',
		descrip: '',
		label: 'Fec. Vto.',
		mascara: 'FechaCorta',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'cuf',
		descrip: '',
		label: 'CUF',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'cant',
		descrip: '',
		label: 'Cantidad',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: '',
		mascara: 'CantidadEntera'
	}
]
